interface CTAProps {
  onConsultClick: () => void;
}

export default function CTA({ onConsultClick }: CTAProps) {
  return (
    <section className="relative py-32 px-6 bg-black">
      <div className="max-w-5xl mx-auto text-center">
        <div className="bg-gradient-to-br from-zinc-900 to-black rounded-3xl border border-red-900/30 p-16 relative overflow-hidden">
          {/* Decorative Elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-red-600/5 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-red-600/5 rounded-full blur-3xl"></div>
          
          <div className="relative z-10">
            <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              Ready to Boost<br />
              <span className="bg-gradient-to-r from-red-600 to-red-400 bg-clip-text text-transparent">
                Your Next Event?
              </span>
            </h2>
            
            <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto">
              Let's discuss how we can create an unforgettable experience tailored to your corporate event goals
            </p>

            <button 
              onClick={onConsultClick}
              className="px-12 py-4 bg-red-600 text-white text-base font-semibold rounded-full hover:bg-red-700 transition-all duration-300 hover:shadow-2xl hover:shadow-red-600/50 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Request a Consultation
            </button>

            <p className="text-gray-500 text-sm mt-6">
              Available for events worldwide • Flexible scheduling • Custom packages
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}